<template>
  <div id="review" class="fac-voice">
    <div v-if="isDisplay" class="fac-voice-header">
      <h2>この施設のGoogleの口コミ</h2>
      <p class="fac-point">
        <kcs-rating
          :rating="detail.rating || 0"
          :enable-score="true"
          :place-id="detail.place_id"
          :enable-review-link="true"
          @click.native="
            handleAnalyticsTrackEvent(
              'facility_detail',
              'click',
              'review_more',
              1
            )
          "
        />
      </p>
    </div>
    <div v-if="isDisplay" class="fac-voice-body">
      <kcs-review-item
        v-for="(review, index) in detail.reviews"
        :key="index"
        :rating="review.rating"
        :comment="review.text"
      />
    </div>
    <p v-if="isWriteReview" class="btn-wrapper">
      <a
        :href="writeReviewUrl"
        @click="
          handleAnalyticsTrackEvent(
            'facility_detail',
            'click',
            'review_post',
            1
          )
        "
        class="btn to-index"
        target="_blank"
        >この施設の口コミを書く</a
      >
    </p>
  </div>
</template>

<script>
import { methods } from '@/utils/methods'
import KcsRating from '@/components/atoms/kcs-rating.vue'
import KcsReviewItem from '@/components/molecules/kcs-review-item.vue'
export default {
  components: {
    KcsRating,
    KcsReviewItem
  },
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  computed: {
    isWriteReview() {
      return this.detail.place_id
    },
    isDisplay() {
      return this.detail.reviews.length && this.isWriteReview
    },
    writeReviewUrl() {
      if (!this.detail.place_id) return ''
      return methods.getWriteReviewUrl(this.detail.place_id)
    }
  }
}
</script>
